<template>
  <div :class="{'form-group': true, 'has-error': error}">
    <label class="col-md-3"><span class="required-label">*</span>{{label}}</label>
    <div class="col-md-4">
      <select
        :name="name"
        class="form-control"
        v-model="val"
        v-validate="'required'"
        @change="handleChange"
      >
        <option :value="null" hidden>Pilih {{label}}</option>
        <option v-for="option in options" :key="option.id" :value="option">{{option}}</option>
      </select>
      <span v-show="error" class="error-label">Pilih {{label}}</span>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  data () {
    return {
      val: null,
      error: false
    }
  },
  mounted () {
    api.get(`/v2/data_khusus/${this.nomorPendaftar}/${this.name}`)
      .then(response => {
        this.val = response.data.data.value
        this.$emit('input-select-change', {name: this.name, value: response.data.data.value})
      })
      .catch(e => {
        this.$emit('input-select-change', {name: this.name, value: null})
      })
    this.$root.$on('input-khusus-validate', this.validate)
  },
  computed: {
    options () {
      return this.meta.split(',')
    },
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    }
  },
  props: ['name', 'label', 'meta'],
  methods: {
    handleChange () {
      this.$emit('input-select-change', {name: this.name, value: this.val})
      this.validate()
    },
    validate () {
      this.val === null ? this.error = true : this.error = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/Select.vue